document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;

  /* ===============================
   MOBILE – INTRO SWIPE
  =============================== */
  if (
    window.innerWidth < 768 &&
    body.classList.contains("template-page-tik-tok")
  ) {
    if (!localStorage.getItem("brownie_tiktok")) {
      document
        .querySelectorAll(".tiktok_info")
        .forEach((el) => el.classList.add("first_active"));
      document
        .querySelectorAll(".mi-layout")
        .forEach((el) => el.classList.add("ocultar_loading"));
      document.getElementById("header")?.classList.add("active_opacity");
    } else {
      document
        .querySelectorAll(".loader_tiktok")
        .forEach((el) => el.classList.add("d-flex"));
    }

    const capa = document.querySelector(".tiktok_info.first_active");
    let startY = 0;
    let endY = 0;

    if (capa) {
      capa.addEventListener("touchstart", (e) => {
        startY = e.changedTouches[0].screenY;
      });

      capa.addEventListener("touchend", (e) => {
        endY = e.changedTouches[0].screenY;
        handleSwipe();
      });
    }

    function handleSwipe() {
      const diffY = startY - endY;
      if (diffY > 50) {
        document
          .querySelectorAll(".tiktok_info")
          .forEach((el) => el.classList.remove("first_active"));
        document.getElementById("header")?.classList.remove("active_opacity");
        document
          .querySelectorAll(".mi-layout")
          .forEach((el) => el.classList.remove("ocultar_loading"));
        localStorage.setItem("brownie_tiktok", "true");
      }
    }
  }

  /* ===============================
   BACK ARROW
  =============================== */
  document.addEventListener("click", function (e) {
    if (
      e.target.closest(".flecha_atras") &&
      body.classList.contains("template-page-tik-tok")
    ) {
      history.back();
    }
  });
});

/* ===============================
 DESKTOP ARROWS SCROLL
=============================== */
document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  if (!body.classList.contains("template-page-tik-tok")) return;
  if (window.innerWidth <= 767) return;

  const upArrow = document.querySelector(".flechas .up");
  const downArrow = document.querySelector(".flechas .down");
  const scrollContainer = document.querySelector(".bloque-derecho");
  const flechas = document.querySelector(".flechas");

  if (!upArrow || !downArrow || !scrollContainer) return;

  function updateArrowsTiktok() {
    const scrollTop = scrollContainer.scrollTop;
    const bloques = scrollContainer.querySelectorAll(".bloque-scroll");
    const tolerance = 1;

    if (!bloques.length) return;

    // UP
    if (scrollTop <= 0) {
      upArrow.src = window.arrowInactive;
      upArrow.classList.add("inactive");
    } else {
      upArrow.src = window.arrowActive;
      upArrow.classList.remove("inactive");
    }

    // DOWN
    const lastBloque = bloques[bloques.length - 1];
    const lastBottom = lastBloque.offsetTop + lastBloque.offsetHeight;
    const containerBottom = scrollTop + scrollContainer.clientHeight;

    if (containerBottom >= lastBottom - tolerance) {
      downArrow.src = window.arrowInactive;
      downArrow.classList.add("inactive");
    } else {
      downArrow.src = window.arrowActive;
      downArrow.classList.remove("inactive");
    }

    flechas.style.display = "flex";
  }

  scrollContainer.addEventListener("scroll", updateArrowsTiktok, {
    passive: true,
  });

  upArrow.addEventListener("click", () => {
    if (!upArrow.classList.contains("inactive")) {
      scrollContainer.scrollBy({
        top: -scrollContainer.clientHeight,
        behavior: "smooth",
      });
    }
  });

  downArrow.addEventListener("click", () => {
    if (!downArrow.classList.contains("inactive")) {
      scrollContainer.scrollBy({
        top: scrollContainer.clientHeight,
        behavior: "smooth",
      });
    }
  });

  updateArrowsTiktok();
});

/* ===============================
 SNAP RESTORE
=============================== */
(function () {
  const body = document.body;
  if (!body.classList.contains("template-page-tik-tok")) return;

  const STORAGE_KEY = "brownie_snap";
  const MAX_TIME = 2 * 60 * 1000;

  function restoreSnap() {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) return;

    const data = JSON.parse(saved);
    const now = Date.now();

    if (now - data.timestamp <= MAX_TIME) {
      const targetBlock = document.querySelector(
        `[data-brownie-tiktok="${data.blockId}"]`,
      );

      if (targetBlock) {
        targetBlock.scrollIntoView({ behavior: "instant", block: "start" });

        if (window.innerWidth < 768 && data.scrollLeft !== undefined) {
          const container = targetBlock.querySelector(".articulos");
          container?.scrollTo({
            left: data.scrollLeft,
            behavior: "instant",
          });
        }
      }
    }

    localStorage.removeItem(STORAGE_KEY);
  }

  function saveSnapOnClick() {
    document.querySelectorAll(".articulo-link").forEach((link) => {
      link.addEventListener("click", function () {
        const parentSnap = link.closest(".bloque-scroll");
        const parentId = parentSnap?.getAttribute("data-brownie-tiktok");
        const container = link.closest(".articulos");
        const scrollLeft = container ? container.scrollLeft : 0;

        if (parentId) {
          localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({
              blockId: parentId,
              scrollLeft,
              timestamp: Date.now(),
            }),
          );
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    restoreSnap();
    saveSnapOnClick();
  });

  window.addEventListener("pageshow", function (event) {
    if (event.persisted) restoreSnap();
  });
})();

/* ===============================
 VIDEO LOADER
=============================== */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".video-container").forEach((container) => {
    const video = container.querySelector("video");
    const loader = container.querySelector(".loader_tiktok");
    const bloque = container.closest(".bloque-scroll");
    const articulos = bloque?.querySelector(".articulos");

    if (!video || !loader) return;

    const hideLoader = () => {
      loader.classList.add("d-none");
      loader.classList.remove("d-flex");
      articulos?.classList.remove("loading_active");
    };

    video.addEventListener("playing", hideLoader);

    if (!video.paused && !video.ended) {
      hideLoader();
    }
  });
});
